export default [
    {
        path: '/assessmentConf',
        component: () => import('@/views/assessment/config/assessmentConf'),
    },

    {
        path: '/assessmentRecordLevel1Table',
        component: () => import('@/views/assessment/record/assessmentRecordLevel1Table'),
    },
    {
        path: '/assessmentRecordLevel2Table',
        component: () => import('@/views/assessment/record/assessmentRecordLevel2Table'),
    },
    {
        path: '/assessmentVersion',
        component: () => import('@/views/assessment/version/assessmentVersion'),
    },
    {
        path: '/assessment',
        component: () => import('@/views/assessment/assessment'),
    },
]